import { useParams, Navigate } from 'react-router-dom'
import CrudPage from '@/components/crud/CrudPage'
import { configs } from './configs'

export default function CadastroResource() {
  const { resource } = useParams()
  const config = configs[resource]

  if (!config) return <Navigate to="/cadastro" replace />

  return <CrudPage config={config} backTo="/cadastro" backLabel="Cadastros" />
}
